module.exports = __webpack_public_path__ + "b26ed7bfa82558bbffe8ca41e6006d19.png";